import { useAuthStore } from '@/features/auth/store/auth-store';
import { esEmpresaDemo } from './empresa-demo';

/**
 * Soporte («Entrar como») dentro de una empresa demo SÓLO MIRA (decisión de Sebastián, 1-nov):
 * no crea, edita, importa, aplica ni aprueba nada en nombre de la persona. La regla vive acá y
 * las pantallas sólo preguntan `useSoporteSoloMira()`. Fuera de una demo no cambia nada.
 */
export const AVISO_SOLO_MIRA = 'Estás mirando como soporte: no se pueden hacer cambios.';

/** La regla pura: soporte y empresa demo a la vez. */
export function soloMiraEnLaDemo(enSoporte: boolean, empresaDemo: boolean): boolean {
  return enSoporte && empresaDemo;
}

/** ¿Esta pantalla debe dejar sus acciones que cambian datos desactivadas? */
export function useSoporteSoloMira(): boolean {
  const enSoporte = useAuthStore((s) => s.isImpersonating);
  return soloMiraEnLaDemo(enSoporte, esEmpresaDemo());
}

/**
 * Atributos para un botón de acción: desactivado y con el aviso como ayuda (title, que los
 * lectores de pantalla leen como descripción). Con `false` no agrega nada.
 */
export function atributosSoloMira(soloMira: boolean): { disabled?: true; title?: string } {
  return soloMira ? { disabled: true, title: AVISO_SOLO_MIRA } : {};
}

/*
  Lo que el servidor le frena a soporte en CUALQUIER empresa, no sólo en una demo
  (`frenarASoporte` y `frenarEscriturasASoporte`): crear o cambiar claves de API, personas e
  invitaciones (le dejarían a alguien un acceso después de la sesión de soporte), marcar alertas
  como vistas y sumar o pedir tiendas a nombre de la persona. Misma respuesta: 403 con el código de
  «soporte sólo mira». Fuera de esta lista, en una empresa común soporte puede lo que el
  servidor le deja.
*/
export const AVISO_SOPORTE_NO_PUEDE =
  'En una sesión de soporte esto no se hace: lo hace la persona, o la plataforma desde su panel.';

/** ¿La sesión es de soporte («Entrar como»), en cualquier empresa? */
export function useEnSoporte(): boolean {
  return useAuthStore((s) => s.isImpersonating);
}

/** Como `atributosSoloMira`, para lo que soporte no hace en ninguna empresa. */
export function atributosSoporteNoPuede(enSoporte: boolean): { disabled?: true; title?: string } {
  return enSoporte ? { disabled: true, title: AVISO_SOPORTE_NO_PUEDE } : {};
}
